import apiClient from "../../../utilities/apiClient";

export const addVendorMaterialGroup = (payload) => {
  return apiClient.post(`${apiClient.Urls.vendor_material_group_master}`, payload, true);
};

export const getVendorMaterialGroups = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.vendor_material_group_master}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const updateVendorMaterialGroup = (id, payload) => {
  return apiClient.put(`${apiClient.Urls.vendor_material_group_master}/${id}`, payload, true);
};

export const deleteVendorMaterialGroup = (id) => {
  return apiClient.delete(`${apiClient.Urls.vendor_material_group_master}/${id}`, {}, true);
};
